import {
    FETCH_DATA_ME_GROUPS_REQUEST,
    FETCH_DATA_ME_GROUPS_SUCCESS,
    FETCH_DATA_ME_GROUPS_FAILURE,
} from '../../actions/groups/get-me-groups-actions';

const initialState = {
    list: [],
    isLoading: false,
    error: null,
    meta: null
};

const getMeGroupsReducer = (state = initialState, action: any) => {
    switch (action.type) {
        case FETCH_DATA_ME_GROUPS_REQUEST:
            return {
                ...state,
                isLoading: true,
                error: null,
            };
        case FETCH_DATA_ME_GROUPS_SUCCESS:
            return {
                ...state,
                isLoading: false,
                list: action.payload.values,
                meta: action.payload.meta
            };
        case FETCH_DATA_ME_GROUPS_FAILURE:
            return {
                ...state,
                isLoading: false,
                error: action.payload,
            };
        default:
            return state;
    }
};

export default getMeGroupsReducer;